import * as R from 'ramda';

export const findCurrencyFromName = (name, currencyList) => R.find(
  ({ value }) => value === name, currencyList
);
